import React from 'react';
import FAQ from '../../components/FAQ';
import Layout from '../../components/Layout';
import Pricing from '../../components/Pricing';
import SEO from '../../components/SEO';
import * as P from '../../partials/GA17';

const GA17 = () => {
  return (
    <Layout>
      <P.Hero />
      <P.HowItWorks />
      <P.Features />
      <Pricing plans={P.plans} />
      <FAQ faq={P.faq} />
    </Layout>
  );
};

export default GA17;

export const Head = () => (
  <SEO
    title="Email Studio for Gmail - Add Powers to Gmail"
    description="Schedule recurring emails, send smart auto-replies, bulk forward emails and automatically tidy your Gmail inbox."
  />
);
